import {setGraneroTarget} from '@apps-common/geocorn-sdk/api';

export const AWS_EU_CENTRAL_1 = 'aws-eu-central-1';
export const AWS_US_WEST_2 = 'aws-us-west-2';
export const GCP_US_CENTRAL_1 = 'gcp-us-central1';

export const SERVER_URLS = {
  [AWS_EU_CENTRAL_1]: 'https://api.eu-1.planet.com',
  [AWS_US_WEST_2]: 'https://api.us-2.planet.com',
  [GCP_US_CENTRAL_1]: 'https://api.us-1.planet.com',
};

const urls = {
  base: import.meta.env.VITE_API_BASE_URL ?? 'https://api.planet.com',
  basemaps: import.meta.env.VITE_BASEMAPS_API_BASE ?? '/basemaps/v1',
  // sceneTiles and basemapTiles configs look the same in prod, but internally they are 2 separate services (webtiles & yats)
  // this allows flexibility if we need to test with internal routes
  basemapTiles:
    import.meta.env.VITE_BASEMAPS_TILES_BASE_URL ??
    'https://tiles.planet.com/basemaps/v1',
  basemapTilesDomainTemplate:
    import.meta.env.VITE_BASEMAPS_TILES_DOMAIN_TEMPLATE ??
    'https://tiles{0-3}.planet.com/basemaps/v1',
  blobz: import.meta.env.VITE_BLOBZ_API_URL ?? '/apps/v0/b',
  data: import.meta.env.VITE_DATA_API_URL ?? '/data/v1',
  dataCollections:
    import.meta.env.VITE_DATA_COLLECTIONS_URL ??
    'https://api.eu-1.planet.com/byoc/v1/collections',
  globalDataCollections: 'https://api.eu-1.planet.com/byoc/v1/global',
  destinations: import.meta.env.VITE_DESTINATIONS_API_URL ?? '/destinations/v1',
  explorerUtils: '/explorer-utils',
  features: setGraneroTarget(import.meta.env.VITE_GRANERO_TARGET ?? 'live'),
  ims: import.meta.env.VITE_IMS_URL ?? 'https://api.eu-1.planet.com/account/v2',
  orders: import.meta.env.VITE_ORDERS_API_URL ?? '/compute/ops/orders/v2',
  pdaAdmin: import.meta.env.VITE_PDA_ADMIN_URL ?? '/account/v1',
  sceneTiles:
    import.meta.env.VITE_SCENE_TILES_BASE_URL ??
    'https://tiles.planet.com/data/v1',
  sceneTilesDomainTemplate:
    import.meta.env.VITE_SCENE_TILES_DOMAIN_TEMPLATE ??
    'https://tiles{0-3}.planet.com/data/v1',
  subscriptions:
    import.meta.env.VITE_SUBSCRIPTIONS_API_URL ?? '/subscriptions/v1',
  accessControl: 'https://api.eu-1.planet.com/api/v1/acl',
  configuration: 'https://api.eu-1.planet.com/api/v2/configuration',
  catalog: 'https://api.eu-1.planet.com/catalog/v1',
  process: 'https://api.eu-1.planet.com/api/v1/process',
  processV2: 'https://api.eu-1.planet.com/api/v2/process',
  shServiceLocations: 'https://api.eu-1.planet.com/api/v1/metadata/location',
};

export default urls;
